import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    readonly #messageService = inject(MessageService);

    showSuccess(summary: string, detail?: string): void {
        this.#messageService.add({
            severity: 'success',
            summary,
            detail,
            life: 5000,
        });
    }

    showInfo(summary: string, detail?: string): void {
        this.#messageService.add({
            severity: 'info',
            summary,
            detail,
            life: 5000,
        });
    }

    showWarning(summary: string, detail?: string): void {
        this.#messageService.add({
            severity: 'warn',
            summary,
            detail,
            life: 7000,
        });
    }

    showError(summary: string, detail?: string): void {
        this.#messageService.add({
            severity: 'error',
            summary,
            detail,
            life: 10000,
        });
    }

    clearAll(): void {
        this.#messageService.clear();
    }
}
